module.exports = __webpack_public_path__ + "static/lights25-d16b5ffd1ee9e4ef3ea5ddbdcc9114f4.jpg";